<template>
  <div>
    <b-card
        border-variant="secondary"
        header-bg-variant="secondary"
        header-text-variant="white"
        :header="$t('unitChanges.changeHeader')"
        :title= "getTitle"
        align="center"
        class="mx-auto"
        style="max-width: 40rem;"
    >
      <b-form @submit.prevent="applyChange">
      <!-- NOTE: VuePhoneNumberInput will not take css variables for colors, so the default color is black, the valid and error colors are bootstrap defaults. -->
      <VuePhoneNumberInput v-model="phoneDetails"
                           show-code-on-list
                           size="md"
                           color="#000000"
                           valid-color="#28a745"
                           error-color="#dc3545"
                           :preferred-countries="['US']"
                           @update="resultsExample = $event"
                           :translations="{
                            countrySelectorLabel: $t('unitChanges.countryCode'),
                            countrySelectorError: $t('unitChanges.invalidCountry'),
                            phoneNumberLabel: $t('unitChanges.phoneLabel'),
                            example: $t('unitChanges.phoneExampleHeader')
                          }"
      />
        <b-button type="submit" class="m-2" variant="outline-primary">{{$t('buttonDefaults.change')}}</b-button>
        <b-button @click="onCancel" class="m-2" variant="outline-primary" >{{ $t("buttonDefaults.cancel")}}</b-button>
      </b-form>
    </b-card>
  </div>
</template>

<script>

import store from "../store/store";
import unitApi from "@/services/unitApi";
import router from "@/router";
import VuePhoneNumberInput from 'vue-phone-number-input';

export default {
  name: 'ChangeUnitPhoneDetails',
  props: {
    changeRequested: { type: String }
  },
  components: {
    VuePhoneNumberInput,
  },
  data() {
    return {
      phoneDetails: null,
      resultsExample:null,
      unit: {
        contact: {
          contactName: "",
          phoneNumber: "",
          email: ""
        }
      }
    }
  },
  mounted() {
    this.unit.contact.contactName = store.getters.getUnitContactName
    this.unit.contact.email = store.getters.getUnitContactEmail
    this.unit.contact.phoneNumber = store.getters.getUnitContactPhone
  },

  computed: {
    getTitle() {
      if (this.changeRequested === "contactName") {
        return this.$t('unitChanges.contactNameTitle')
      } else if (this.changeRequested === "email") {
        return this.$t('unitChanges.emailTitle')
      } else {
        return this.$t('unitChanges.phoneNumberTitle')
      }
    },
    getLabel() {
      if (this.changeRequested === "contactName") {
        return this.$t('unitDetails.contactName')
      } else if (this.changeRequested === "email") {
        return this.$t('unitDetails.contactEmail')
      } else {
        return this.$t('unitDetails.phoneNumber')
      }
    }
  },
  methods: {
    async applyChange(evt) {
      evt.preventDefault()
      try {
        if(this.resultsExample === undefined || this.resultsExample.isValid===false){
          this.$bvToast.toast( this.$t('unitChanges.phoneNumberInvalid'), {
            title: this.$t('unitChanges.phoneInvalidTitle'),
            autoHideDelay: 5000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
          return;
        }
        this.unit.contact.phoneNumber=this.resultsExample.formatInternational
        await unitApi.updateUnit(store.getters.getTenantGuid, this.unit)
        await store.dispatch("loadUnitInformationFromApi")
        router.push({name: 'Unit'})
      }catch(e){
        if(e.response !== undefined && e.response.status === undefined && e.response.status === 409  || e.response.status === 400) {
          this.$bvToast.toast( e.response.data.message, {
            title: this.$t('unitDetailChangeFailed.phoneTitle'),
            autoHideDelay: 5000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        }
        else {
              this.$bvToast.toast( this.$t('unitDetailChangeFailed.unitDetailsUpdateErrorMsg'), {
                title: this.$t('unitDetailChangeFailed.phoneTitle'),
                autoHideDelay: 10000,
                toaster: "b-toaster-top-center",
                variant: "warning",
                append: false,
                solid: false
              })
            }
      }
    },
    onCancel() {
      router.push({ name: 'Unit'})
    }
  }
}
</script>
